import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQS = [
  {
    q: 'How do I play the Golden Catch?',
    a: 'Sign up, verify your email, then buy R5 tickets from the Buy a Ticket page. Every ticket auto-enters the next Friday 6PM SAST draw.',
  },
  {
    q: 'When is the draw?',
    a: 'Every Friday at 18:00 (6PM) South African Standard Time. Winners are notified by email and published on Previous Winners.',
  },
  {
    q: 'How do I claim my prize?',
    a: 'Winners are contacted directly. Prizes are paid out via EFT to a verified South African bank account after KYC verification is complete.',
  },
  {
    q: 'Is there an age restriction?',
    a: 'Yes. You must be 18 or older to sign up or play. Age is verified at signup and again during KYC.',
  },
  {
    q: 'Why do you need KYC?',
    a: 'South African law requires identity verification before we can pay out prizes. Upload your ID document and a selfie in your dashboard.',
  },
  {
    q: 'Are refunds available?',
    a: 'All ticket sales are final. Refunds are not offered once a purchase is completed.',
  },
  {
    q: 'Is there a ticket limit?',
    a: 'You can buy up to 100 tickets per single purchase. There is no weekly cap, but please play responsibly.',
  },
  {
    q: 'What payment methods are accepted?',
    a: 'Card payments via AddPay (coming soon). During this beta, purchases are simulated for testing.',
  },
  {
    q: 'How will I know if I win?',
    a: 'You will receive an email and an in-app message on your dashboard. Winners also appear on the Previous Winners page.',
  },
  {
    q: 'Where can I get help with gambling problems?',
    a: 'Please play responsibly. If gambling is affecting your life, call the National Responsible Gambling Programme on 0800 006 008.',
  },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-3">Answers</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl font-black">
        <span className="text-gold-gradient">Frequently Asked Questions</span>
      </h1>
      <p className="mt-3 text-[#C0C0C0]">Everything you need to know before your first Golden Catch.</p>

      <div className="mt-10 card-embossed p-4 sm:p-6">
        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#D4AF37]/15 last:border-b-0"
            >
              <AccordionTrigger
                data-testid={`faq-q-${i}`}
                className="text-left text-white hover:text-[#D4AF37] py-5 [&[data-state=open]]:text-[#D4AF37]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#C0C0C0] pb-5 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
